/* eslint-disable no-restricted-globals */
import { getMessaging, isSupported, onBackgroundMessage } from 'firebase/messaging/sw'
import { initializeApp } from 'firebase/app'

export const firebaseConfig = {
  apiKey: 'AIzaSyDHF3B8ynFGGHwsDZNZuaOn4xiVGuytz9k',
  authDomain: 'securitas-gea.firebaseapp.com',
  projectId: 'securitas-gea',
  storageBucket: 'securitas-gea.appspot.com',
  messagingSenderId: '907188761597',
  appId: '1:907188761597:web:e33b3081b745fc26261f94'
}

self.addEventListener('activate', (event) => {
  event.waitUntil(self.clients.claim())
})

self.addEventListener('install', function (event) {
  console.log('[Service Worker] Installing Service Worker ...', event)
  self.skipWaiting()
})

self.addEventListener('activate', function (event) {
  console.log('[Service Worker] Activating Service Worker ....', event)

  isSupported()
    .then((result) => {
      if (!result) {
        console.warn('Firebase is not supported')
        return
      }
      const app = initializeApp(firebaseConfig)
      const messaging = getMessaging(app)
      onBackgroundMessage(messaging, (payload) => {
        const { notification } = payload
        const { title, body } = notification

        self.registration.showNotification(title, {
          body,
          icon: '/images/pwa/notification_512.png'
        })
      })
    })

})

self.addEventListener('fetch', function (event) {
  event.respondWith(
    fetch(event.request)
  )
})
